export const UNTITLED_SHELL_THREAD_LABEL = "Untitled chat";

export function getShellThreadDisplayName(thread: {
  threadName: string | null;
}): string {
  return thread.threadName ?? UNTITLED_SHELL_THREAD_LABEL;
}

export function filterShellThreadsByName<
  T_Thread extends { threadName: string | null },
>(threads: readonly T_Thread[], query: string): T_Thread[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return [...threads];
  return threads.filter((thread) =>
    getShellThreadDisplayName(thread).toLowerCase().includes(needle),
  );
}
